module.exports = __webpack_public_path__ + "static/media/arrow-up-black.f8bf9f6b.svg";